class Banner {
  fileName: string;
  bannerUrl: string;
  constructor() {
    this.fileName = '';
    this.bannerUrl = '';
  }

  static mappingBanner(obj: any) {
    const banner = new Banner();
    banner.fileName = obj.FileName || '';
    banner.bannerUrl = obj.BannerUrl || '';

    return banner;
  }
}

export default class eventBanner {
  categoryId: string;
  categoryName: string;
  banners: Banner[];
  constructor() {
    this.categoryId = '';
    this.categoryName = '';
    this.banners = [];
  }

  static mappingObject(_obj: any[]) {
    const listGenericBanner: eventBanner[] = [];
    _obj.forEach(itm => {
      const obj = new eventBanner();
      let listBanner = [];
      if (Array.isArray(itm.Banners)) {
        listBanner = itm.Banners.map((banner: any) => {
          return Banner.mappingBanner(banner);
        });
      }
      obj.categoryId = itm.CategoryID;
      obj.categoryName = itm.CategoryName;
      obj.banners = listBanner;

      listGenericBanner.push(obj);
    });

    return listGenericBanner;
  }

  static mappingObjectBanner(_obj: any) {
    return Banner.mappingBanner(_obj);
  }
}
